import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DetailedOrder, OrderItem} from "../../services/site-user.service";
import {LabelaryService} from "../../services/labelary.service";
import {timer} from "rxjs";
import {AlertService} from "../../services/alert.service";
import {HttpErrorResponse} from "@angular/common/http";
import {finalize} from "rxjs/operators";

const AD_BLOCKER_TEST_DELAY = 500;

const AD_BLOCKER_WARNING =
    "It seems your ad blocker is preventing the direct viewing of this file.<br/>" +
    "You can disable the blocker and try again.";

@Component({
    selector: 'rr-order-info',
    templateUrl: './order-info.component.html',
    styleUrls: ['./order-info.component.css']
})
export class OrderInfoComponent implements OnInit, OnDestroy {

    @Input() order: DetailedOrder;
    private image_object_url: string;
    loading: boolean = false;
    currentItem: OrderItem;

    constructor(private labelary: LabelaryService,
                private alertService: AlertService) {
    }

    ngOnInit() {

    }

    ngOnDestroy() {
        if (this.image_object_url)
            URL.revokeObjectURL(this.image_object_url);
    }

    viewShippingLabel(item: OrderItem) {
        this.loading = true;
        this.currentItem = item;
        this.labelary.getLabel(item.zpl_label).pipe(
            finalize(() => {this.loading = false})
        ).subscribe((pngImage) => {
            this.image_object_url = URL.createObjectURL(pngImage);
            this.viewUrlInTab(this.image_object_url);
        }, (err: HttpErrorResponse) => {
            this.alertService.error(err.message);
        })
    }

    private viewUrlInTab(url: string) {
        const ref = window.open(url, "_blank");
        timer(AD_BLOCKER_TEST_DELAY).subscribe(() => {
            if (!ref.window)
                this.alertService.warn(AD_BLOCKER_WARNING);
        });
    }
}
